<div id="svolgi-cognitivo">
  <iframe [src]="supportUrl" width="100%" frameBorder="0" scrolling="yes" [height]="height"></iframe>
  <div class="bottone-conferma">
    <button pButton pRipple type="submit" label="Chiudi" class="p-button" (click)="saveQuestionarioAndBack()"
      style="width:100%; height:41px;"></button>
  </div>
</div>
